export default __webpack_public_path__ + "static/media/344.6115381e.jpg";